import { supabase } from './supabase';

interface SendEmailParams {
  to: string;
  subject: string;
  html: string;
  type: 'newsletter' | 'password-reset';
}

export async function sendEmail({ to, subject, html, type }: SendEmailParams) {
  try {
    const response = await fetch(
      `${import.meta.env.VITE_SUPABASE_URL}/functions/v1/send-email`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${import.meta.env.VITE_SUPABASE_ANON_KEY}`,
        },
        body: JSON.stringify({ to, subject, html, type }),
      }
    );

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || 'Failed to send email');
    }

    return await response.json();
  } catch (error) {
    console.error('Error sending email:', error);
    throw error;
  }
}

export function generatePasswordResetEmail(resetLink: string) {
  return `
    <div style="font-family: sans-serif; max-width: 600px; margin: 0 auto;">
      <h1 style="color: #1e40af;">Reset Your Password</h1>
      <p>You recently requested to reset your password for your PropViper admin account. Click the button below to reset it:</p>
      <a 
        href="${resetLink}" 
        style="display: inline-block; background-color: #2563eb; color: white; padding: 12px 24px; text-decoration: none; border-radius: 6px; margin: 16px 0;"
        target="_blank"
        rel="noopener noreferrer"
      >
        Reset Password
      </a>
      <p style="color: #64748b; font-size: 14px;">
        If you did not request a password reset, please ignore this email or contact support if you have concerns.
      </p>
      <hr style="border: none; border-top: 1px solid #e2e8f0; margin: 24px 0;" />
      <p style="color: #64748b; font-size: 12px;">
        This email was sent by PropViper. Please do not reply to this email.
      </p>
    </div>
  `;
}